import { render, staticRenderFns } from "./MyBottomSheet.vue?vue&type=template&id=bd4ec08a&scoped=true&"
import script from "./MyBottomSheet.vue?vue&type=script&lang=js&"
export * from "./MyBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./MyBottomSheet.vue?vue&type=style&index=0&id=bd4ec08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4ec08a",
  null
  
)

export default component.exports